import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { otpValidation } from 'src/app/models/otpValidation.model';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-verification-login',
  templateUrl: './verification-login.component.html',
  styleUrls: ['./verification-login.component.scss'],
})
export class VerificationLoginComponent implements OnInit {
  otp: string = '';
  otpVerificationScreen: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  maskedAccountNo: string = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '●',
    inputStyles: {
      width: '50px',
      height: '50px',
    },
  };
  showSubscriptionTemplate: boolean = false;
  showSuccessTemplate: boolean = false;
  sku: any;
  additionalBenefits: any;
  howtoSubscribe: any;
  termsCondition: any;
  currentAccount: any;
  showOTP: boolean = false;
  main: any;
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService
  ) {
  
  }
  ngDestory() {
    this.showSubscriptionTemplate = false;
    this.showSuccessTemplate = false;
    this.showOTP = false;
    this.SS.addonBuySuccessfully.unsubscribe();
  }

  ngAfterContentInit(){
    this.SS.currentAccount.subscribe((r) => {
      this.currentAccount = r;
      this.mobileNumber = this.currentAccount.accountNo;
    });
    this.SS.subscribeLogin.subscribe((r) => {
      if(r == true){
        this.showOTP = true;
      }
    });
  }
  async ngOnInit() {
    this.sku = this.SKUDS.get();
    await this.skuDetails(this.sku.skuId).then((r) => (this.sku = r));
    if (
      this.sku &&
      this.sku.additionalBenefits &&
      this.sku.additionalBenefits.links &&
      this.sku.additionalBenefits.links.href
    ) {
      this.additionalBenefits = await this.skuadditional(
        this.sku.additionalBenefits.links.href
      );
    }

    if (
      this.sku &&
      this.sku.howtoSubscribe &&
      this.sku.howtoSubscribe.links &&
      this.sku.howtoSubscribe.links.href
    ) {
      this.howtoSubscribe = await this.skuadditional(
        this.sku.howtoSubscribe.links.href
      );
    }
    if (this.sku && this.sku.tc_en) {
      this.termsCondition = this.sku.tc_en.split('. ');
    }
    this.SS.sku.subscribe((main) => {
      this.main = main; 
      if (
        main &&
        main.name &&
        main.value &&
        main.value.categoryTitle &&
        this.sku &&
        this.sku.displayName &&
        (this.sku.id || this.sku.skuId) &&
        this.sku.listPrice
      ) {
        this.GAS.productDetailImpression(
          main.name,
          main.value.categoryTitle,
          this.sku.displayName,
          this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
          this.sku.listPrice,
          'Etisalat'
        );
      }
    });
  }

  private async skuDetails(id: string) {
    const response = await this.SKUDS.geteShopSKU(id)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

  private async skuadditional(link: string) {
    const response = await this.SKUDS.getAdditionalSkus(link)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  getOTP() {
    this.productService
      .getMobileEligibility(this.mobileNumber)
      .subscribe((resp) => {
        if (resp.status == 1) {
          this.productService
            .generateOTP(this.mobileNumber)
            .subscribe((resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.otpVerificationScreen = true;
            });
        }
      });
  }

  changeOTP(otp: string) {
    this.otp = otp;
  }

  validateOtp() {
    this.otpValidationModel.accountNo = this.mobileNumber;
    this.otpValidationModel.authValue = this.otp;
    this.otpValidationModel.authType = 'otp';
    this.productService
      .validateOTP(this.otpValidationModel)
      .subscribe((resp) => {
        //   if(resp.success) this.route.navigate(['/success'])
        this.SS.account.next(this.mobileNumber);
        if (resp.success) {
          this.GAS.OTPVerification(this.main.name,'Submit')
          this.AAS.OTPVerification(this.main.name,'Submit')
          this.showSubscriptionTemplate = true;
        }
        else{
          this.GAS.OTPVerification(this.main.name,'Error')
          this.AAS.OTPVerification(this.main.name,'Error')
        }
      });
  }
}
